import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { WagmiProvider } from 'wagmi'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { config } from './config/wagmi'
import { AuthProvider } from './context/AuthContext'
import { ThemeProvider } from './context/ThemeContext'
import ConnectWallet from './pages/ConnectWallet'
import CreateProfile from './pages/CreateProfile'
import EditProfile from './pages/EditProfile'
import Home from './pages/Home'
import ProfileView from './pages/ProfileView'
import AdminPanel from './pages/AdminPanel'
import ContactUs from './pages/ContactUs'
import Leaderboard from './pages/Leaderboard'
import ScoutProfile from './pages/ScoutProfile'
import ClaimVerification from './pages/ClaimVerification'
import MyScoutedProfiles from './pages/MyScoutedProfiles'
import ProtectedRoute from './components/ProtectedRoute'
import { Toaster } from 'sonner'
import './App.css'

const queryClient = new QueryClient()

function App() {
  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <AuthProvider>
            <Router>
              <Routes>
                <Route path="/connect" element={<ConnectWallet />} />
                <Route
                  path="/create-profile"
                  element={
                    <ProtectedRoute>
                      <CreateProfile />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/edit-profile"
                  element={
                    <ProtectedRoute>
                      <EditProfile />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/home"
                  element={
                    <ProtectedRoute>
                      <Home />
                    </ProtectedRoute>
                  }
                />
                {/* Public profile view - no auth required */}
                <Route path="/profile/:username" element={<ProfileView />} />
                {/* Contact Us - no auth required */}
                <Route path="/contact-us" element={<ContactUs />} />
                {/* Leaderboard - no auth required */}
                <Route path="/leaderboard" element={<Leaderboard />} />
                {/* Admin panel - protected route */}
                <Route
                  path="/admin-panel"
                  element={
                    <ProtectedRoute>
                      <AdminPanel />
                    </ProtectedRoute>
                  }
                />
                {/* Scout profile - create claimable profile */}
                <Route
                  path="/scout-profile"
                  element={
                    <ProtectedRoute>
                      <ScoutProfile />
                    </ProtectedRoute>
                  }
                />
                {/* Claim verification - verify claimed profile */}
                <Route
                  path="/claim-verification"
                  element={
                    <ProtectedRoute>
                      <ClaimVerification />
                    </ProtectedRoute>
                  }
                />
                {/* My Scouted Profiles - view profiles you've created */}
                <Route
                  path="/my-scouted-profiles"
                  element={
                    <ProtectedRoute>
                      <MyScoutedProfiles />
                    </ProtectedRoute>
                  }
                />
                <Route path="/" element={<Navigate to="/connect" replace />} />
                {/* Catch-all route for any undefined paths */}
                <Route path="*" element={<Navigate to="/connect" replace />} />
              </Routes>
            </Router>
            <Toaster position="top-right" richColors />
          </AuthProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </WagmiProvider>
  )
}

export default App